(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloom-professionnels"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const cards = [...root.querySelectorAll('[data-product]')];
    if (!form || !cards.length) return;
    const summary = root.querySelector('[data-summary]');
    const error = root.querySelector('[data-selection-error]');
    const first = cards[0].querySelector('[data-quantity]');
    let attempted = false;
    function update() {
      const lines = [];
      cards.forEach(card => {
        const select = card.querySelector('[data-quantity]');
        const exact = card.querySelector('[data-exact]');
        const more = select.value === '500+';
        card.querySelector('[data-exact-wrap]').hidden = !more;
        exact.disabled = !more;
        card.classList.toggle('is-selected', !!select.value);
        if (select.value) {
          const qty = more ? (exact.value && exact.validity.valid ? exact.value + ' ' + summary.dataset.unit : summary.dataset.more) : select.value + ' ' + summary.dataset.unit;
          lines.push(card.dataset.name + ' — ' + qty);
        }
      });
      summary.textContent = lines.length ? lines.join('\n') : summary.dataset.empty;
      first.setCustomValidity(lines.length ? '' : error.textContent.trim());
      error.hidden = !attempted || !!lines.length;
      first.setAttribute('aria-invalid', String(attempted && !lines.length));
    }
    form.addEventListener('change', update);
    form.addEventListener('input', update);
    first.addEventListener('invalid', () => { attempted = true; update(); });
    form.addEventListener('submit', event => {
      attempted = true;
      update();
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
    });
    update();
  }
  document.querySelectorAll('[data-bloom-quote]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bloom-quote]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
